import React, { memo } from 'react';
import VerticalLayout from 'components/VerticalLayout';
import type { List } from 'lib/LobbyEntities';
import withLazyStyle from 'components/LazyStyle';
import Builder, { type Mapping } from '../../../Builder';
import style from './columnList.css?lazy';

interface ColumnListProps {
  list: List;
  mapping: Mapping;
}

const ColumnList = ({ list, mapping }: ColumnListProps) => (
  <VerticalLayout className="dynamicLobby__listVertical">
    {list.children.map(({ __access }, index) => (
      <Builder key={__access} accessRef={__access} mapping={mapping} position={index + 1} />
    ))}
  </VerticalLayout>
);

export default memo(withLazyStyle(style)(ColumnList));
